export default "__VITE_ASSET__DtaZaUoX__"